import { Directive, ElementRef, AfterViewInit } from '@angular/core';

@Directive({ 
  selector: '[myAppendSubmenuIcon]',
  standalone: true
})

export class AppendSubmenuIconDirective implements AfterViewInit {
  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
  }
}
